"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardPlayerPage = exports.playerInfoContext = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const context_1 = require("@lit/context");
const app_main_1 = require("../layout/app-main");
const defs_1 = require("../lib/anchor/defs");
const defs_2 = require("../lib/defs");
// playerInfoContext
exports.playerInfoContext = (0, context_1.createContext)(Symbol("player-info"));
let OnboardPlayerPage = (() => {
    var _OnboardPlayerPage_anchorClient_accessor_storage, _OnboardPlayerPage_nftStorageClient_accessor_storage, _OnboardPlayerPage_playerInfo_accessor_storage, _OnboardPlayerPage_processing_accessor_storage;
    let _classDecorators = [(0, decorators_js_1.customElement)("onboard-player-page")];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = lit_1.LitElement;
    let _instanceExtraInitializers = [];
    let _anchorClient_decorators;
    let _anchorClient_initializers = [];
    let _nftStorageClient_decorators;
    let _nftStorageClient_initializers = [];
    let _playerInfo_decorators;
    let _playerInfo_initializers = [];
    let _processing_decorators;
    let _processing_initializers = [];
    var OnboardPlayerPage = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _OnboardPlayerPage_anchorClient_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _anchorClient_initializers, null)));
            _OnboardPlayerPage_nftStorageClient_accessor_storage.set(this, __runInitializers(this, _nftStorageClient_initializers, null));
            _OnboardPlayerPage_playerInfo_accessor_storage.set(this, __runInitializers(this, _playerInfo_initializers, null));
            _OnboardPlayerPage_processing_accessor_storage.set(this, __runInitializers(this, _processing_initializers, ""));
        }
        get anchorClient() { return __classPrivateFieldGet(this, _OnboardPlayerPage_anchorClient_accessor_storage, "f"); }
        set anchorClient(value) { __classPrivateFieldSet(this, _OnboardPlayerPage_anchorClient_accessor_storage, value, "f"); }
        get nftStorageClient() { return __classPrivateFieldGet(this, _OnboardPlayerPage_nftStorageClient_accessor_storage, "f"); }
        set nftStorageClient(value) { __classPrivateFieldSet(this, _OnboardPlayerPage_nftStorageClient_accessor_storage, value, "f"); }
        get playerInfo() { return __classPrivateFieldGet(this, _OnboardPlayerPage_playerInfo_accessor_storage, "f"); }
        set playerInfo(value) { __classPrivateFieldSet(this, _OnboardPlayerPage_playerInfo_accessor_storage, value, "f"); }
        get processing() { return __classPrivateFieldGet(this, _OnboardPlayerPage_processing_accessor_storage, "f"); }
        set processing(value) { __classPrivateFieldSet(this, _OnboardPlayerPage_processing_accessor_storage, value, "f"); }
        onCreateCharacter(e) {
            return __awaiter(this, void 0, void 0, function* () {
                const { name, portrait } = e.detail;
                if (this.anchorClient && this.nftStorageClient) {
                    this.processing = "uploading portrait to IPFS ...";
                    // Create NFT Storage for portrait
                    const uri = yield this.nftStorageClient.storeImageFromUrl({
                        name,
                        description: "",
                        imageUrl: portrait,
                    });
                    console.log(`Stored portrait at ${uri}`);
                    // Create & fetch player
                    this.processing = `creating player ${name}, entity, creatures ...`;
                    yield this.anchorClient.createPlayer(name, uri);
                    this.processing = `fetching player ${name} ...`;
                    yield this.fetchPlayer();
                    // go to game on success created
                    window.location.href = "/game";
                }
            });
        }
        fetchPlayer() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.anchorClient) {
                    const playerInfo = yield this.anchorClient.getPlayerInfo();
                    if (playerInfo) {
                        this.playerInfo = playerInfo; // set context
                    }
                }
            });
        }
        firstUpdated() {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.fetchPlayer();
            });
        }
        willUpdate(changedProperties) {
            return __awaiter(this, void 0, void 0, function* () {
                if (changedProperties.has("anchorClient")) {
                    // Try to create the world (might already be created and throw error)
                    if (this.anchorClient && defs_1.WORLD_ID < 0) {
                        yield this.anchorClient.initializeWorld();
                    }
                    yield this.fetchPlayer();
                }
            });
        }
        getWelcomePlayer() {
            const player = this.playerInfo.player;
            const portrait = this.playerInfo.portrait;
            return (0, lit_1.html) `
      <h1>Welcome ${player.name}</h1>
      <img src="${portrait}" class="portrait" />
      <br />
      <a href="/game">
        <sl-button type="submit" variant="primary">Enter Yggdrasil</sl-button>
      </a>
    `;
        }
        getOnboardPlayer() {
            return (0, lit_1.html) `
      <h1>Create your character</h1>
      <p class="processing">${this.processing}</p>
      <form-event @on-submit=${this.onCreateCharacter}>
        <form action="submit" slot="form">
          <!-- Name -->
          <sl-input
            label="Name"
            name="name"
            help-text="What is your character's name?"
            required
          ></sl-input>
          <br />
          <!-- Portrait -->
          ${Object.entries(defs_2.DEFAULT_PORTRAITS).map(([imageId, imagePath]) => {
                return (0, lit_1.html) `
              <input
                type="radio"
                name="portrait"
                id="${imageId}"
                class="hidden portrait-input"
                value="${imagePath}"
                required
              />
              <label for="${imageId}">
                <img src="${imagePath}" alt="${imageId}" class="portrait" />
              </label>
            `;
            })}
          <br />
          <sl-button type="submit" variant="primary">Enter Yggdrasil</sl-button>
        </form>
      </form-event>
    `;
        }
        render() {
            return this.playerInfo ? this.getWelcomePlayer() : this.getOnboardPlayer();
        }
    };
    _OnboardPlayerPage_anchorClient_accessor_storage = new WeakMap();
    _OnboardPlayerPage_nftStorageClient_accessor_storage = new WeakMap();
    _OnboardPlayerPage_playerInfo_accessor_storage = new WeakMap();
    _OnboardPlayerPage_processing_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "OnboardPlayerPage");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _anchorClient_decorators = [(0, context_1.consume)({ context: app_main_1.anchorClientContext, subscribe: true }), (0, decorators_js_1.state)()];
        _nftStorageClient_decorators = [(0, context_1.consume)({ context: app_main_1.nftStorageClientContext, subscribe: true }), (0, decorators_js_1.state)()];
        _playerInfo_decorators = [(0, context_1.provide)({ context: exports.playerInfoContext }), (0, decorators_js_1.state)()];
        _processing_decorators = [(0, decorators_js_1.state)()];
        __esDecorate(_classThis, null, _anchorClient_decorators, { kind: "accessor", name: "anchorClient", static: false, private: false, access: { has: obj => "anchorClient" in obj, get: obj => obj.anchorClient, set: (obj, value) => { obj.anchorClient = value; } }, metadata: _metadata }, _anchorClient_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _nftStorageClient_decorators, { kind: "accessor", name: "nftStorageClient", static: false, private: false, access: { has: obj => "nftStorageClient" in obj, get: obj => obj.nftStorageClient, set: (obj, value) => { obj.nftStorageClient = value; } }, metadata: _metadata }, _nftStorageClient_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _playerInfo_decorators, { kind: "accessor", name: "playerInfo", static: false, private: false, access: { has: obj => "playerInfo" in obj, get: obj => obj.playerInfo, set: (obj, value) => { obj.playerInfo = value; } }, metadata: _metadata }, _playerInfo_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _processing_decorators, { kind: "accessor", name: "processing", static: false, private: false, access: { has: obj => "processing" in obj, get: obj => obj.processing, set: (obj, value) => { obj.processing = value; } }, metadata: _metadata }, _processing_initializers, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        OnboardPlayerPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = (0, lit_1.css) `
    .hidden {
      display: none;
    }
    .portrait {
      height: 150px;
      padding: 5px;
    }
    .portrait:hover {
      outline: 2px solid #3498db;
    }
    .portrait-input:checked + label img {
      outline: 2px solid #e74c3c;
    }
    .processing {
      color: red;
    }
  `;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return OnboardPlayerPage = _classThis;
})();
exports.OnboardPlayerPage = OnboardPlayerPage;
